import { faHome, faMoneyBill1Wave, faQrcode, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Accordion, Button, Card, Container, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import auxService from "../../services/AuxService";
import { formatDate, formatMoeda } from "../../utils/utils";
import { AuthContext } from "../../contexts/AuthContext";

interface Tenant {
    id: number;
    grupo: string;
    name: string;
    data_vencimento: string;
    limite_empresas: number;
    total: number;
    empresas: Empresa[],
    active: boolean;
    mensalidades: any[];
    pagamentos: any[];
    vencido: boolean;
}

interface Empresa {
    name: string;
    cnpj: string;
    insc_estadual: string;
    fone: string;
    celular: string;
}
const initial: Tenant = {
    id: 0,
    grupo: '',
    name: '',
    data_vencimento: '',
    total: 0,
    empresas: [],
    limite_empresas: 0,
    active: false,
    mensalidades: [],
    pagamentos: [],
    vencido: false
};

interface QrCodeProps {
    qrcode: string;
    image: string;
    documento: string;
    valor: number;

}

export default function IndexAssinatura() {

    const [tenant, setTenant] = useState<Tenant>(initial);
    const [activeKey, setActiveKey] = useState<string | undefined>(undefined);
    const authContext = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        fetchTenant();
    }, []);

    useEffect(() => {
        const requestInterval = setInterval(() => {

            if (tenant.mensalidades[0]?.documento !== undefined &&
                tenant.mensalidades[0]?.documento !== "" &&
                tenant.mensalidades[0].status === "ATIVA"

            ) {
                auxService.getStatusAssinatura(tenant.mensalidades[0]?.documento)
                    .then(res => {
                        if (res?.status === "CONCLUIDA") {
                            navigate('/dashboard');
                        }
                    }).catch(error => {
                        console.log(error);
                    });
            }
        }, 10000); //10s

        return () => clearInterval(requestInterval);
    }, [tenant?.mensalidades]);

    useEffect(() => {
        if (tenant?.mensalidades?.length > 0) {
            setActiveKey('0');
        } else {
            setActiveKey(undefined);
        }
    }, [tenant?.mensalidades]);

    const fetchTenant = async () => {
        auxService.getTenant().then(res => {
            setTenant(res);
        });
    }

    const openQrCode = (value: QrCodeProps) => {
        navigate('/qrcode', {
            state: {
                qrcode: value.qrcode,
                image: value.image,
                documento: value.documento,
                valor: value.valor,
                tipo: 'assinatura'

            }
        });
    }

    return (<Container className="d-flex justify-content-center align-items-center vh-100">
        <Card className="card-primary card-outline">

            {((tenant.vencido && tenant.mensalidades?.length === 0) || !tenant.active) && (
                <Card.Header className="d-flex justify-content-between">
                    <Link to="/assinatura/create" className="">
                        <Button variant="success" className="">
                            <FontAwesomeIcon icon={faMoneyBill1Wave} className="me-1" />
                            {tenant.active ? 'Efetuar assinatura' : 'Reativar Assinatura'}
                        </Button>
                    </Link>
                </Card.Header>
            )}

            <Card.Body>

                <Table striped bordered hover responsive>
                    <thead >
                        <tr>
                            <th>CNPJ Raiz</th>
                            <th>Nome do Tenant</th>
                            <th>Data de Expiração</th>
                            <th>Num. licenças</th>
                            <th>Valor</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody className="table-group-divider">
                        {tenant.id > 0 && (
                            <tr key={tenant.id}>
                                <td>{tenant.grupo}</td>
                                <td>{tenant.name}</td>
                                <td className="text-center">
                                    {
                                        new Date(tenant.data_vencimento).toLocaleDateString('pt-BR')
                                    }
                                </td>
                                <td className="text-center">{tenant.limite_empresas}</td>
                                <td className="text-center">{formatMoeda(tenant.total)}</td>
                                <td className="text-center">{tenant.active ? 'Ativa' : 'Inativa'}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                <Accordion activeKey={activeKey} >
                    <Accordion.Item eventKey="0"  >
                        <Accordion.Header>
                            <div className="text-danger" >Pagamentos em aberto</div>
                        </Accordion.Header>
                        <Accordion.Body className="p-2">
                            <Table striped bordered hover responsive className="mb-0">
                                <thead >
                                    <tr>
                                        <th className="text-center">Tipo</th>
                                        <th className="text-center">Id. Pagamento</th>
                                        <th className="text-center">Data pagamento</th>
                                        <th className="text-center">Valor</th>
                                        <th className="text-center">Status</th>

                                        <th className="text-center">QRCode</th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {tenant.mensalidades?.map((p) =>
                                    (
                                        <tr key={p.id}>
                                            <td className="text-center">Assinatura</td>
                                            <td className="text-center">{p?.documento}</td>
                                            <td className="text-center">{p?.data_pagamento}</td>
                                            <td className="text-center">{formatMoeda(p?.valor)}</td>
                                            <td className="text-center">{p?.status}</td>
                                            <td className="text-center">
                                                {p.status === 'ATIVA' && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        onClick={() => openQrCode(
                                                            {
                                                                documento: p.documento,
                                                                image: p.image_qrcode,
                                                                qrcode: p.qrcode,
                                                                valor: p.valor
                                                            }
                                                        )}
                                                    >
                                                        <FontAwesomeIcon icon={faQrcode} />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    )

                                    )}
                                </tbody>
                            </Table>

                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>

                <Accordion className="mt-3">
                    <Accordion.Item eventKey="0"  >
                        <Accordion.Header  >
                            <div className="text-primary">Pagamentos pagos</div>
                        </Accordion.Header>
                        <Accordion.Body className="p-2">
                            <Table striped bordered hover responsive className="mb-0">
                                <thead >
                                    <tr>
                                        <th className="text-center">Tipo</th>
                                        <th className="text-center">Id. Pagamento</th>
                                        <th className="text-center">Data pagamento</th>
                                        <th className="text-center">Valor</th>
                                        <th className="text-center">Status</th>
                                        <th className="text-center">QRCode</th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {tenant.pagamentos?.map((p) =>
                                    (
                                        <tr key={p.id}>
                                            <td className="text-center">Assinatura</td>
                                            <td className="text-center">{p?.documento}</td>
                                            <td className="text-center">{
                                                formatDate(p?.data_pagamento, "dd/MM/YYY HH:mm:ss")
                                            }
                                            </td>
                                            <td className="text-center">{formatMoeda(p?.valor)}</td>
                                            <td className="text-center">{p?.status_devolucao !== null ? p?.status_devolucao : p?.status}</td>
                                            <td className="text-center">
                                                {p.status === 'ATIVA' && (
                                                    <Link to={''}
                                                        onClick={() => openQrCode(
                                                            {
                                                                documento: p.documento,
                                                                image: p.image_qrcode,
                                                                qrcode: p.qrcode,
                                                                valor: p.valor
                                                            }
                                                        )}
                                                    >
                                                        <FontAwesomeIcon icon={faQrcode} />
                                                    </Link>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>

            </Card.Body>
            <Card.Footer className="d-flex justify-content-between">
                <Link to="/dashboard" className="">
                    <Button variant="secondary" className="">
                        <FontAwesomeIcon icon={faHome} /> Voltar</Button>
                </Link>

                <Button variant="danger" onClick={authContext?.logout}>
                    <FontAwesomeIcon icon={faRightFromBracket} /> Sair</Button>

            </Card.Footer>
        </Card>
    </Container>)
}